
import { Box } from '@mui/material'
import React from 'react'
import ExportDataasCSV from '../../../GlobalComponents/ExportDataasCSV'

export default function BankDataDownload() {
  return (
    <div
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height
    //backgroundColor: '#4caf50', // Optional background color
  }}
>
  <div
    style={{
      color: 'white',
      padding: '8px 16px',
      borderRadius: '4px',
      textAlign: 'center', // Optional for centering text inside
    }}
  >
    <ExportDataasCSV
           exportEndpoint="/export-detail-data"
           buttonTitle="Download Details CSV File"
           buttonColor="warning"
           downloadedFileName="details.csv"
          />
  </div>
</div>
  )
}

 
          
          
          

 